import React from "react";
import { InfoText } from "../../../data/types/InfoText";
import { InfoContent } from "../../content/InfoContent/InfoContent";
import {
  StyledBaseSection,
  StyledBaseSectionInner,
} from "../../styled/BaseSection.styled";

export const Founder: React.FC<InfoText> = ({ title, descriptions }) => {
  return (
    <StyledBaseSection>
      <StyledBaseSectionInner>
        <InfoContent title={title} descriptions={descriptions} />
      </StyledBaseSectionInner>
    </StyledBaseSection>
  );
};
